import { render, staticRenderFns } from "./BePlainTable.vue?vue&type=template&id=e890a11e&scoped=true&slot-scope=scope&"
import script from "./BePlainTable.vue?vue&type=script&lang=js&"
export * from "./BePlainTable.vue?vue&type=script&lang=js&"
import style0 from "./BePlainTable.vue?vue&type=style&index=0&id=e890a11e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e890a11e",
  null
  
)

export default component.exports